
const initState = {
  menuItemData: [
    "1",
    "2",
  ],
  userPoint: 0,
  userInfo: null,
  loading: false,

  menu: null,

  actionDialog: {
    isOpen: false
  },
  alertDialog: {
    isOpen: false,
    content: "",
  },

};

const itemReducer = (state = initState, action) => {
  switch (action.type) {
    case 'ADD_ITEM': {
      const menuItemCopy = state.menuItemData.slice();
      return { menuItemData: [action.payload.itemNew].concat(menuItemCopy) };
    }
    case 'CLEAN_ITEM': {
      return { menuItemData: [] };
    }

    case 'UPDATE_MENU': {
      return { ...state, menu: action.payload.menu };
    }
    case 'UPDATE_USERINFO': {
      return { ...state, userInfo: action.payload.userInfo, userPoint: action.payload.userPoint };
    }
    case 'UPDATE_USERINFO': {
      return { ...state, userInfo: action.payload.userInfo, userPoint: action.payload.userPoint };
    }
    case 'UPDATE_USERPOINT': {
      return { ...state, userPoint: action.payload.userPoint };
    }
    case 'UPDATE_LOADING': {
      return { ...state, loading: action.payload.loading };
    }
    case 'UPDATE_ACTIONDIALOG': {
      return { ...state, actionDialog: action.payload.actionDialog };
    }
    case 'UPDATE_ALERTDIALOG': {
      return { ...state, alertDialog: action.payload.alertDialog };
    }
    default:
      return state;
  }
};


export { itemReducer };